import { SxProps, Theme } from "@mui/material";

// Common style objects for SettingsReport
export const settingsReportStyles = {
  // Container styles
  container: {
    width: "100%",
    padding: 3,
    backgroundColor: "#F7FCFF",
    borderBottom: "1px solid #E0E0E0",
  } as SxProps<Theme>,

  // Main title styles
  mainTitle: {
    fontFamily: '"Georgia", "Times New Roman", serif',
    color: "#1B4F72",
    fontSize: { xs: "2rem", md: "2.5rem" },
    fontWeight: "bold",
    marginBottom: 1,
  } as SxProps<Theme>,

  // Subtitle styles
  subtitle: {
    fontFamily: '"Poppins", sans-serif',
    color: "#2C8BB0",
    fontSize: { xs: "0.75rem", md: "0.875rem" },
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  } as SxProps<Theme>,

  // Summary box styles
  summaryBox: {
    backgroundColor: "white",
    border: "1px solid #E0E0E0",
    borderRadius: 2,
    padding: 2.5,
    boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
  } as SxProps<Theme>,

  // The filters box's top-right corner (SettingsReport's settingsAction),
  // floated so the first filter row wraps beside it instead of under it.
  settingsAction: {
    float: "right",
    marginTop: -1,
    marginRight: -1,
    marginLeft: 1,
  } as SxProps<Theme>,

  // Summary item container styles
  summaryItem: {
    marginBottom: 2,
  } as SxProps<Theme>,

  // Label styles (for Client, Period, Accounts labels)
  label: {
    fontFamily: '"Poppins", sans-serif',
    color: "#1B4F72",
    fontSize: "0.875rem",
    fontWeight: "bold",
    display: "inline-block",
    marginRight: 1,
  } as SxProps<Theme>,

  // Value styles (for Client, Period, Accounts values)
  value: {
    fontFamily: '"Poppins", sans-serif',
    color: "#1B4F72",
    fontSize: "0.875rem",
    fontWeight: 400,
  } as SxProps<Theme>,

  // Period chip styles
  periodChipContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 0.5,
  } as SxProps<Theme>,

  periodChip: {
    fontFamily: '"Poppins", sans-serif',
    fontSize: "0.75rem",
  } as SxProps<Theme>,
};
